import React from 'react';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import { dataAttrs } from 'Helpers/Testing';

export const AccountOpeningV2KYCLockedOutStepLayout = () => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack spacing={3} direction="column">
      <ImageRel relationship={resource.relationship(fr.relationships.image.name)} />
      <MetaControlField attr="title" />
      <MetaControlField attr="description" />
      <MetaLayoutRemainingFields noAccordion />
      <FDStack direction="column" alignItems="center" spacing={2}>
        <PrimaryActionButtonRel
          {...dataAttrs('continue-btn', resource)}
          relationship={resource.relationship(fr.relationships.messagesPage.name)}
        />
      </FDStack>
    </FDStack>
  );
};
